import { useEffect } from "react";
import { gql } from "@/services/httpAdapter.ts";
import { useSubscriptions } from "@Common/context/subscriptions/Subscriptions";
import { useQueryClient } from "@tanstack/react-query";

type TResult = {
	locationId?: string;
	commissionCycleId?: string;
	payPeriodId?: string;
};

const useCitExportHistorySubs = (params: TResult) => {
	const { locationId = "", commissionCycleId = "", payPeriodId = "" } = params;
	const queryClient = useQueryClient();
	const { addSubscription, getSubscription } = useSubscriptions();

	const createCitExportHistorySubscription = getSubscription(["createCitExportHistory", locationId, commissionCycleId, payPeriodId]);

	createCitExportHistorySubscription?.subscriptions?.onCreateCitExportHistory?.setCallback(
		(_result: { data: { onCreateCitExportHistory: TResult } }) => {
			queryClient.refetchQueries({
				queryKey: ["contractsInTransitExportHistory", locationId, commissionCycleId, payPeriodId],
				exact: true,
			});
		}
	);

	useEffect(() => {
		if (locationId && commissionCycleId) {
			addSubscription(
				["createCitExportHistory", locationId, commissionCycleId, payPeriodId],
				[
					{
						context: "onCreateCitExportHistory",
						query: gql`
							subscription onCreateCitExportHistory($locationId: String!, $commissionCycleId: String, $payPeriodId: String) {
								onCreateCitExportHistory(
									locationId: $locationId
									commissionCycleId: $commissionCycleId
									payPeriodId: $payPeriodId
								) {
									locationId
									commissionCycleId
									payPeriodId
								}
							}
						`,
						variables: {
							locationId,
							commissionCycleId,
							payPeriodId,
						},
					},
				]
			);
		}
		return () => {};
	}, [locationId, commissionCycleId, payPeriodId]);
};

export default useCitExportHistorySubs;
